<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card" v-if="company">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{ 'Raw Data ' }} {{ selTab }}</strong>
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(selComp)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-secondary"
              :to="{ name: 'pTrends', props: { isIndividual: 0 } }">
              <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
              <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-warning" @click.prevent="viewCalculatedData(selComp)">
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(selComp)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select :options="companyList" :placeholder="'Select Company'" :label="'companyname'" v-model="selComp"
              @input="getCompRawData">
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
      </div>
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData" v-if="company.companyname != ''">
        <!-- index<29 -->
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index" v-if="index < 38">
          <div class="mb5"></div>
          <div class="row mb5"
            v-if="rawDataType === 'peer_comparison' || rawDataType === 'peer_comparison_balancesheet'">
            <div class="col-md-3 form-group">
              <select class="form-control" name="compareParam" v-model="param" @change="paramChange">
                <option value="balancesheet">Balance Sheet</option>
                <option value="financialratio">Financial Ratio</option>
                <option value="profitloss">Profit &amp; Loss</option>
              </select>
            </div>
            <div class="col-md-2">
              <button class="btn btn-sm btn-primary" @click="compareCompanies">Go</button>
            </div>
            <div class="col-md-2" v-if="isCompared">
              <button class="btn btn-sm btn-primary" @click="backToCompare">Back</button>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true"
            v-if="rawDataType !== 'peer_comparison' && rawDataType !== 'peer_comparison_balancesheet' && rawDataType !== 'directors_reports'">
            <div class="row mb5">
              <div class="col-md-10">
                <div class="col-md-4" style="margin-bottom: 14px;" v-if="rawDataType === 'score_board'">
                  <div style="width: 120px">
                    <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="ddate"
                      @selected="getDateData($event)"></datepicker>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <download :tableId="rawDataType" :fileName="company.companyname + '-' + rawDataType"></download>
              </div>
            </div>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner" v-if="rawDataType === 'balance_sheet' ||
              rawDataType === 'balance_sheet_c' ||
              rawDataType === 'balance_sheet_s' ||
              rawDataType === 'profit_and_loss' ||
              rawDataType === 'profit_and_loss_c' ||
              rawDataType === 'profit_and_loss_s' ||
              rawDataType === 'annual_result' ||
              rawDataType === 'annual_result_c' ||
              rawDataType === 'annual_result_s' ||
              rawDataType === 'annual_profit_and_loss_result' ||
              rawDataType === 'annual_profit_and_loss_result_c' ||
              rawDataType === 'annual_profit_and_loss_result_s' ||
              rawDataType === 'annual_cashflow_result' ||
              rawDataType === 'annual_cashflow_result_c' ||
              rawDataType === 'annual_cashflow_result_s' ||
              rawDataType === 'cashflow' ||
              rawDataType === 'cashflow_c' ||
              rawDataType === 'cashflow_s' ||
              rawDataType === 'quarterly_result' ||
              rawDataType === 'quarterly_result_c' ||
              rawDataType === 'quarterly_result_s' ||
              rawDataType === 'half_yearly_result' ||
              rawDataType === 'half_yearly_result_c' ||
              rawDataType === 'half_yearly_result_s'">
              <thead>
                <tr>
                  <th class="data-cell" v-for="(field, index, key) in tableFields"
                    v-bind:key="'field' + field.rowind + index + key">{{ (index > 0) ? field.title : "" }}</th>
                </tr>
              </thead>
              <tbody v-for="(row, index) in rawData" v-bind:key="'row' + row + index">
                <tr v-if="(row.columnname || row.ColumName || row.COLUMNNAME)">
                  <td v-for="field in tableFields" v-bind:key="'td' + field.title + index">
                    <span class="data-labels"
                      v-if="field.title == 'ColumName' || field.title == 'columnname' || field.title == 'COLUMNNAME'">
                      <strong>{{ capitalizeFirstLetter(row[field.title]) }}</strong>
                    </span>
                    <span v-else>
                      <span
                        v-if="(rawDataType === 'balance_sheet' || rawDataType === 'balance_sheet_c' || rawDataType === 'balance_sheet_s')">
                        <!-- <span v-if="(row.rownumber === '1' || row.rownumber === '18')"></span> -->
                        <span v-if="checkIfHeader(row['columnname'])"></span>
                        <span v-else>{{ (row[field.rowind] !== null) ? getFixed(row[field.rowind]) : (row[field.rowind]
                          == 0
                          || row[field.rowind] == "0") ? 0 : '-' }}</span>
                      </span>
                      <span
                        v-else-if="(rawDataType === 'profit_and_loss' || rawDataType === 'profit_and_loss_c' || rawDataType === 'profit_and_loss_s')">
                        <!-- <span
                          v-if="(row.rownumber === '1' || row.rownumber === '14' || row.rownumber === '0')"
                        ></span> -->
                        <span v-if="checkIfHeader(row['columnname'])"></span>
                        <span v-else>{{ (row[field.rowind] !== null) ? getFixed(row[field.rowind]) : (row[field.rowind]
                          == 0
                          || row[field.rowind] == "0") ? 0 : '-' }}</span>
                      </span>
                      <span
                        v-else-if="(rawDataType === 'cashflow' || rawDataType === 'cashflow_c' || rawDataType === 'cashflow_s')">
                        <!-- <span
                          v-if="(row.rowno === '6' || row.rowno === '18' || row.rowno === '32' || row.rowno === '39' || row.rowno === '51' ||row.rowno === '56' || row.rowno === '74' || row.rowno === '84')"
                        ></span> -->
                        <span v-if="checkIfHeader(row['columnname'])"></span>
                        <span v-else>{{ (row[field.rowind] !== null) ? getFixed(row[field.rowind]) : (row[field.rowind]
                          == 0
                          || row[field.rowind] == "0") ? 0 : '-' }}</span>
                      </span>
                      <span v-else>{{ (row[field.rowind] !== null) ? getFixed(row[field.rowind]) : (row[field.rowind] ==
                        0 ||
                        row[field.rowind] == "0") ? 0 : '-' }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'share_holding_pattern'">
              <thead>
                <tr>
                  <th v-for="field in tableFields" v-bind:key="'title' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rw, index) in rawData" v-bind:key="'tr' + index">
                  <td v-for="(field, ind) in tableFields" v-bind:key="'td' + field.title">{{ (ind == 0) ?
                    getQuarterString(rw[field.title]) : getFixed(rw[field.title]) }}</td>
                </tr>
              </tbody>
            </table>
            <sharePrices v-if="rawDataType === 'mf_holding'" :rdType="rawDataType" :comp="company"
              :columns="tableFields" :rows="tableRows" :issuesData="mfHoldingData" />
            <sharePrices v-if="rawDataType === 'price_bse' || rawDataType === 'price_nse'" :rdType="rawDataType"
              :comp="company" :columns="tableFields" :rows="tableRows" :issuesData="rawData" />
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'index_constituents' || rawDataType === 'avg_trade_volume'">
              <tbody>
                <tr v-for="field in tableFields" v-bind:key="'td' + field.title + index">
                  <td class="text-bold">{{ field.name }}</td>
                  <td>{{ (field.isNumeric) ? getChecknFixed(rawData[field.title]) : rawData[field.title] }}</td>
                </tr>
              </tbody>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'key_financial_ratios' && rawData.length > 0">
              <thead>
                <tr>
                  <th v-for="(th, index) in tableFields" v-bind:key="'th' + index">{{ th.name }}</th>
                </tr>
              </thead>
              <tbody v-for="(rd, index) in keyFinancialRatios" v-bind:key="'td' + index">
                <tr v-if="rd.ColumName !== 'Year End'">
                  <td v-for="(raw, index) in tableFields" v-bind:key="'td' + index">
                    <span v-if="raw.title === 'ColumName'">{{ rd.ColumName }}</span>
                    <span v-else>{{ rd[raw.title] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 w50 app-inner"
              v-else-if="rawDataType === 'score_board'">
              <tbody :style="Object.keys(rawData).length === 0 ? 'height:300px' : ''">
                <tr v-if="Object.keys(rawData).length > 0" v-for="(th, index) in tableFields" v-bind:key="'th' + index">
                  <th>{{ th.name }}</th>
                  <td>{{ rawData[th.title] }}</td>
                </tr>
              </tbody>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'quote_details' && rawData.length > 0">
              <thead>
                <tr>
                  <th></th>
                  <th>BSE</th>
                  <th>NSE</th>
                </tr>
                <tr>
                  <td style="width: 30%;">Last Price</td>
                  <td>
                    {{ rawData[0].BSE.price }}
                    <br />
                    {{ getFormattedDate(rawData[0].BSE.upd_time) + ' EOD' }}
                  </td>
                  <td>
                    {{ rawData[1].NSE.price }}
                    <br />
                    {{ getFormattedDate(rawData[1].NSE.upd_time) + ' EOD' }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 30%;">Today's Change</td>
                  <td>{{ rawData[0].BSE.change }}</td>
                  <td>{{ rawData[1].NSE.change }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Open</td>
                  <td>{{ rawData[0].BSE.open_price }}</td>
                  <td>{{ rawData[1].NSE.open_price }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Prev Close</td>
                  <td>{{ rawData[0].BSE.oldprice }}</td>
                  <td>{{ rawData[1].NSE.oldprice }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Volume</td>
                  <td>{{ rawData[0].BSE.volume }}</td>
                  <td>{{ rawData[1].NSE.volume }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Today's Range</td>
                  <td>{{ rawData[0].BSE.high_price }} - {{ rawData[0].BSE.low_price }}</td>
                  <td>{{ rawData[1].NSE.high_price }} - {{ rawData[1].NSE.low_price }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">52-Week Range</td>
                  <td>{{ rawData[0].BSE.hi_52_wk }} - {{ rawData[0].BSE.lo_52_wk }}</td>
                  <td>{{ rawData[1].NSE.hi_52_wk }} - {{ rawData[1].NSE.lo_52_wk }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Buy(Size)</td>
                  <td>{{ rawData[0].BSE.bbuy_price }}(X{{ rawData[0].BSE.bbuy_qty }})</td>
                  <td>{{ rawData[1].NSE.bbuy_price }}(X{{ rawData[1].NSE.bbuy_qty }})</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Sell(Size)</td>
                  <td>{{ rawData[0].BSE.bsell_price }}(X{{ rawData[0].BSE.bsell_qty }})</td>
                  <td>{{ rawData[1].NSE.bsell_price }}(X{{ rawData[1].NSE.bsell_qty }})</td>
                </tr>
              </thead>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'board_of_directors' && rawData.length > 0">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="(tc, index) in tableColumns" v-bind:key="index + 'tc' + tc.title">{{ tc.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod' + '-' + ind">
                  <td>{{ ind + 1 }}</td>
                  <td v-for="(cl, index) in tableColumns" v-bind:key="index + 'cldata' + cl.title">
                    {{ (tr.boardOfdirectorslist[cl.title]) ? tr.boardOfdirectorslist[cl.title] : '-' }}</td>
                </tr>
              </tbody>
            </table>
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner"
              v-else-if="rawDataType === 'company_background'">
              <thead v-if="rawData.length > 0">
                <tr>
                  <td style="width: 30%;">Incorporation Year</td>
                  <td>{{ rawData[1].inc_dt }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Registered Office</td>
                  <td>{{ rawData[2].address }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Telephone</td>
                  <td>{{ rawData[1].tel1 }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Fax</td>
                  <td>{{ rawData[1].fax1 }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Chairman</td>
                  <td>{{ rawData[1].chairman }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Managing Director</td>
                  <td>{{ rawData[1].dir_name }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Company Secretary</td>
                  <td>{{ rawData[1].co_sec }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Auditor</td>
                  <td>{{ rawData[1].auditor }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Face Value</td>
                  <td>{{ rawData[1].fv }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Market Lot</td>
                  <td>{{ rawData[1].mkt_lot }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Listing</td>
                  <td>{{ rawData[1].inc_dt }}</td>
                </tr>
                <tr>
                  <td style="width: 30%;">Registrar</td>
                  <td>{{ rawData[2].reg_name }}{{ rawData[2].address }}</td>
                </tr>
              </thead>
            </table>
            <companyNews v-if="rawDataType === 'company_news'" :rdType="rawDataType" :comp="company"
              :columns="tableFields" :rows="tableRows" :newsData="mfHoldingData" />
          </div>
          <div class="row" v-else-if="rawDataType === 'directors_reports' && rawData.directorsreports">
            <div v-html="rawData.directorsreports.directorrep"></div>
          </div>
          <div v-else-if="rawDataType === 'peer_comparison' || rawDataType === 'peer_comparison_balancesheet'">
            <!-- <spinner v-if="isloading"></spinner> -->
            <div v-if="!isCompared">
              <div class="table-responsive app" v-dragscroll="true">
                <table class="table table-bordered w50 fonts11 app-inner">
                  <thead>
                    <tr>
                      <th>
                        <input class="checkall" type="checkbox" @click="selAllCompany($event)" />Select All
                      </th>
                      <th>Company</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(com, ind) in companies" v-bind:key="'com' + ind + com"
                      v-if="(company.companyname).search(com) === -1">
                      <td>
                        <input class="checkall" type="checkbox" @click="addCompany($event)"
                          :checked="checkIfChecked(selectedCompanies, com)" :value="com" />
                      </td>
                      <td>{{ com }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="row mb5">
                <div class="col-md-10"></div>
                <div class="col-md-2">
                  <download :tableId="rawDataType" :fileName="company.companyname + '-' + rawDataType"></download>
                </div>
              </div>
              <div class="row mb5">
                <div class="table-responsive app" v-dragscroll="true">
                  <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th></th>
                        <th v-for="sComp in selectedCompanies" v-bind:key="'company' + sComp">{{ sComp }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="field in tableFields" v-bind:key="'title' + field.title">
                        <td>{{ field.name }}</td>
                        <td v-for="sComp in selectedCompanies" v-bind:key="'company' + sComp">
                          {{ rawData[getKeyIndex(companies, sComp)][field.title] }}
                          <!-- {{rawData[param][getKeyIndex(companies, sComp)][field.title]}} -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </v-tab>
        <v-tab :title="'BSE Board Meetings Forthcoming'">
          <Issues v-if="rawDataType === 'bse_board_meetings'" :rdType="'bse_board_meetings'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'NSE Board Meetings Forthcoming'">
          <Issues v-if="rawDataType === 'nse_board_meetings'" :rdType="'nse_board_meetings'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Corporate Action BM'">
          <Issues v-if="rawDataType === 'corporate_actionBM'" :rdType="'corporate_actionBM'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Corporate Action Bonus'">
          <Issues v-if="rawDataType === 'corporate_actionB'" :rdType="'corporate_actionB'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Corporate Action Rights'">
          <Issues v-if="rawDataType === 'corporate_actionR'" :rdType="'corporate_actionR'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Corporate Action Splits'">
          <Issues v-if="rawDataType === 'corporate_actionS'" :rdType="'corporate_actionS'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'BSE Announcements'">
          <Issues v-if="rawDataType === 'bse_announcements'" :rdType="'bse_announcements'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'NSE Announcements'">
          <Issues v-if="rawDataType === 'nse_announcements'" :rdType="'nse_announcements'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'BSE EOD Announcement'">
          <Issues v-if="rawDataType === 'bse_eod_announcements'" :rdType="'bse_eod_announcements'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Shares Outstanding'">
          <Issues v-if="rawDataType === 'shares_outstanding'" :rdType="'shares_outstanding'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'MCAP Yearly'">
          <Issues v-if="rawDataType === 'mcap_yearly'" :rdType="'mcap_yearly'" :comp="company" :columns="tableColumns"
            :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Yearly Dividend'">
          <Issues v-if="rawDataType === 'yearly_dividend'" :rdType="'yearly_dividend'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Insider Trading'">
          <Issues v-if="rawDataType === 'insider_trading'" :rdType="'insider_trading'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Research & Development'">
          <Issues v-if="rawDataType === 'research_and_development'" :rdType="'research_and_development'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Finished Products'">
          <Issues v-if="rawDataType === 'Finished_Products'" :rdType="'Finished_Products'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Shareholding more than 1%'">
          <Issues v-if="rawDataType === 'Shareholding_MorethanOnePercent'" :rdType="'Shareholding_MorethanOnePercent'"
            :comp="company" :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
        <v-tab :title="'Capital Expenditure'">
          <Issues v-if="rawDataType === 'Capital_Expenditure'" :rdType="'Capital_Expenditure'" :comp="company"
            :columns="tableColumns" :rows="tableRows" :issuesData="rawData" />
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

import Issues from "@/views/company/rawdata/issues";
import sharePrices from "@/views/company/rawdata/sharePrices";
import companyNews from "@/views/company/rawdata/company-news";

export default {
  // props: ["company"],
  components: { Datepicker, VueTabs, VTab, Issues, sharePrices, companyNews },
  mixins: [commonMixins, rawMixins],
  created() {
    if (!localStorage.getItem("rawtab")) {
      this.rawDataType = this.rawDataList[this.selRowInd].id;
      // this.selTab = this.rawDataList[this.selRowInd].value;
      localStorage.setItem("rawtab", this.rawDataType);
      localStorage.setItem("selTab", this.selTab);
    } else {
      this.rawDataType = localStorage.getItem("rawtab");
      if (localStorage.getItem("selTab") !== "Balance Sheet")
        this.selTab = localStorage.getItem("selTab");
    }
    console.log("Rawtype", this.rawDataType, this.selTab);
    this.getCompaniesList();
  },
  methods: {
    getDateData(e) {
      this.ddate = new Date(e).toLocaleDateString('en-US').replace(/\//g, '-');;
      console.log("Date Selected", this.ddate);
      this.getRawData();
    },
    getRawData() {
      this.rawData = [];
      this.tableFields = [];
      (this.companies = []),
        (this.selectedCompanies = []),
        (this.isCompSel = true),
        (this.isCompared = false);
      if (this.rawDataType === "peer_comparison") {
        var rowFieldName = this.rawDataType + "_balancesheet";
      } else {
        var rowFieldName = this.rawDataType;
      }
      let self = this;
      let param = { rowFieldName: rowFieldName, co_code: this.company.co_code };
      //rawDataList
      if (this.rawDataType === "score_board") {
        param.insert_date = new Date(self.ddate).toLocaleDateString('en-GB').replace(/\//g, '-');
      }
      console.log('this.rawDataType >>>> ', param);

      http.post(
        this.rawDataApi,
        param,
        (error, response) => {
          console.log("Response", response.data);
          // this.rawData = response.data[0][this.rawDataType];
          if (this.checkInArray(this.tabOneRawDataType, this.rawDataType)) {
            if (
              this.rawDataType === "price_bse" ||
              this.rawDataType === "price_nse"
            ) {
              this.rawData = response.data;
              this.rawData = this.sorted_fields_date(this.rawData, "date");
            } else if (
              this.rawDataType === "board_of_directors" ||
              this.rawDataType === "company_news" ||
              this.rawDataType === "bse_announcements" ||
              this.rawDataType === "nse_announcements" ||
              this.rawDataType === "bse_eod_announcements" ||
              this.rawDataType === "bse_board_meetings" ||
              this.rawDataType === "nse_board_meetings" ||
              this.rawDataType === "shares_outstanding" ||
              this.rawDataType === "mcap_yearly" ||
              this.rawDataType === "yearly_dividend" ||
              this.rawDataType === "insider_trading" ||
              this.rawDataType === "Shareholding_MorethanOnePercent" ||
              this.rawDataType === "Finished_Products" ||
              this.rawDataType === "Capital_Expenditure"
            ) {
              this.rawData = response.data;
            } else if (this.rawDataType === "balance_sheet_c") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["balance_sheet"]
                  : [];
            } else if (this.rawDataType === "balance_sheet_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["balance_sheet"]
                  : [];
            } else if (this.rawDataType === "profit_and_loss_c") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["profit_and_loss"]
                  : [];
            } else if (this.rawDataType === "profit_and_loss_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["profit_and_loss"]
                  : [];
            } else if (this.rawDataType === "annual_result_c") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["annual_result"]
                  : [];
            } else if (this.rawDataType === "annual_result_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["annual_result"]
                  : [];
            }
            //annual_profit_and_loss_result
            //annual_cashflow_result
            else if (this.rawDataType === "annual_profit_and_loss_result" || this.rawDataType === "annual_profit_and_loss_result_c" | this.rawDataType === "annual_profit_and_loss_result_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["annual_profit_and_loss_result"]
                  : [];
            } else if (this.rawDataType === "annual_cashflow_result" || this.rawDataType === "annual_cashflow_result_c" | this.rawDataType === "annual_cashflow_result_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["annual_cashflow_result"]
                  : [];
            }

            else if (this.rawDataType === "cashflow_c") {
              this.rawData =
                response.data.length > 0 ? response.data[0]["cashflow"] : [];
            } else if (this.rawDataType === "cashflow_s") {
              this.rawData =
                response.data.length > 0 ? response.data[0]["cashflow"] : [];
            } else if (this.rawDataType === "quarterly_result_c") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["quarterly_result"]
                  : [];
            } else if (this.rawDataType === "quarterly_result_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["quarterly_result"]
                  : [];
            } else if (this.rawDataType === "half_yearly_result_c") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["half_yearly_result"]
                  : [];
            } else if (this.rawDataType === "half_yearly_result_s") {
              this.rawData =
                response.data.length > 0
                  ? response.data[0]["half_yearly_result"]
                  : [];
            } else if (this.rawDataType === "mf_holding") {
              console.log(
                "mfholdings",
                response.data[0]['mf_holding'].sch_name
              );
              this.rawData =
                response.data.length === 0
                  ? []
                  : Object.keys(response.data[0][this.rawDataType]).length > 0
                    ? response.data[0][this.rawDataType]
                    : [];
            } else {
              this.rawData =
                response.data.length > 0
                  ? response.data[0][this.rawDataType]
                  : [];
            }
            this.setTableValues();
          } else if (
            this.rawDataType === "share_holding_pattern" ||
            this.rawDataType === "corporate_actionBM" ||
            this.rawDataType === "corporate_actionB" ||
            this.rawDataType === "corporate_actionR" ||
            this.rawDataType === "corporate_actionS"
          ) {
            this.rawData = response.data;
            this.setTableValues();
          } else if (this.rawDataType === "quote_details") {
            this.rawData = response.data;
          } else if (this.rawDataType === "company_background") {
            this.rawData = response.data;
          } else if (this.rawDataType === "key_financial_ratios") {
            this.rawData =
              response.data.length > 0
                ? response.data
                : [];
            var tableField = [];
            var i = 1;
            var val = this.rawData[0].keyfinancialratiolist;
            if (this.rawData.length > 0) {
              tableField.push({
                title: "ColumName",
                name: "",
                rowind: 999999,
                isNumeric: false,
                sort_order: 1
              });
              var table_key = Object.keys(
                this.rawData[0].keyfinancialratiolist[0]
              );
              table_key.forEach((tf, key) => {
                i = i + 1;
                if (tf !== "RID" && tf !== "ColumName") {
                  tableField.push({
                    title: tf,
                    rowind: tf.replace("Year", ""),
                    name: this.getQuarterName(
                      this.rawData[0].keyfinancialratiolist[0][tf]
                    ),
                    isNumeric: true,
                    sort_order: i
                  });
                }
              });
              this.tableFields = this.sorted_fields_desc(tableField, "rowind");
              console.log('keyfinancialratiolist', this.tableFields);
            }
          } else if (
            this.rawDataType === "peer_comparison" ||
            this.rawDataType === "peer_comparison_balancesheet"
          ) {
            this.rawData = response.data.length > 0 ? response.data : [];
            this.getCompanies();
          } else if (
            this.rawDataType === "score_board" ||
            this.rawDataType === "index_constituents" ||
            this.rawDataType === "avg_trade_volume"
          ) {
            this.rawData = response.data.length > 0 ? response.data[0] : [];
            this.setTableValues();
          } else {
            this.rawData = response.data.length > 0 ? response.data[0] : [];
          }
          // console.log("this.rawData", this.rawData);
          this.rawDataList[this.selRowInd].items = this.rawData;
          //TODO:: add company updates into our array in future
        }
      );
    },
    getCompanies() {
      var companies = [];
      var _this = this;
      _this.selectedCompanies = [];
      // _this.selectedCompanies.push(_this.company.co_code);
      this.rawData.forEach(function (val, index) {
        console.log(
          _this.company,
          "val.co_code",
          val.coname,
          "_this.company.co_code",
          _this.company.companyname,
          _this.company.companyname.search(val.coname)
        );
        if (
          _this.company.companyname.search(val.coname) !== -1 &&
          !_this.selectedCompanies.includes(val.coname)
        ) {
          _this.currentComp = val.coname;
          _this.selectedCompanies.push(val.coname);
        }
        //&& (_this.company.companyname).search(val.coname) === -1
        if (
          val.coname &&
          val.coname !== null &&
          !companies.includes(val.coname)
        )
          companies.push(val.coname);
      });
      this.companies = companies;
      console.log("companies", this.companies, this.selectedCompanies);
    },
    setTableValues() {
      console.log("set values", this.rawDataType);
      this.downLoadableData = [];
      this.tableFields = [];
      if (
        this.rawDataType === "balance_sheet" ||
        this.rawDataType === "balance_sheet_c" ||
        this.rawDataType === "balance_sheet_s" ||
        this.rawDataType === "profit_and_loss" ||
        this.rawDataType === "profit_and_loss_c" ||
        this.rawDataType === "profit_and_loss_s" ||
        this.rawDataType === "annual_result" ||
        this.rawDataType === "annual_result_c" ||
        this.rawDataType === "annual_result_s" ||
        this.rawDataType === 'annual_profit_and_loss_result' ||
        this.rawDataType === 'annual_profit_and_loss_result_c' ||
        this.rawDataType === 'annual_profit_and_loss_result_s' ||
        this.rawDataType === 'annual_cashflow_result' ||
        this.rawDataType === 'annual_cashflow_result_c' ||
        this.rawDataType === 'annual_cashflow_result_s' ||
        this.rawDataType === "cashflow" ||
        this.rawDataType === "cashflow_c" ||
        this.rawDataType === "cashflow_s" ||
        this.rawDataType === "quarterly_result" ||
        this.rawDataType === "quarterly_result_c" ||
        this.rawDataType === "quarterly_result_s" ||
        this.rawDataType === "half_yearly_result" ||
        this.rawDataType === "half_yearly_result_c" ||
        this.rawDataType === "half_yearly_result_s"
      ) {
        if (
          this.rawDataType === "quarterly_result" ||
          this.rawDataType === "quarterly_result_c" ||
          this.rawDataType === "quarterly_result_s"
        ) {
          this.tableFields.push({
            title: "ColumName",
            name: this.rawData[0].ColumName,
            rowind: "ColumName",
            sort_order: 11111111
          });
          for (let key in this.rawData[0]) {
            if (key !== "RID" && key !== "RowNumber" && key !== "ColumName") {
              console.log(this.getFinancialYear(key, "quarterly_result"));
              this.tableFields.push({
                title: this.getFinancialYear(key, "quarterly_result"),
                name: this.rawData[0][key],
                rowind: key,
                sort_order: key.replace("Year", "")
              });
            } else {
            }
          }
        } else if (
          this.rawDataType === "half_yearly_result" ||
          this.rawDataType === "half_yearly_result_c" ||
          this.rawDataType === "half_yearly_result_s"
        ) {
          console.log("Half Yearly");
          this.tableFields.push({
            title: "COLUMNNAME",
            name: this.rawData[0].COLUMNNAME,
            rowind: "COLUMNNAME",
            sort_order: 11111111
          });
          for (let key in this.rawData[0]) {
            if (key !== "RID" && key !== "rowno" && key !== "COLUMNNAME") {
              console.log(this.getFinancialYear(key, "half_yearly_result"));
              this.tableFields.push({
                title: this.getFinancialYear(key, "half_yearly_result"),
                name: this.rawData[0][key],
                rowind: key,
                sort_order: key.replace("Year", "")
              });
            } else {
            }
          }
          console.log(this.tableFields);
        } else {

          console.log('###=> ', this.rawData)
          if (this.rawData[0].columnname) {
            this.tableFields.push({
              title: "columnname",
              name: this.rawData[0].columnname,
              rowind: "columnname",
              sort_order: 11111111
            });

            for (let key in this.rawData[0]) {
              if (
                key !== "rid" &&
                key !== "rownumber" &&
                key !== "columnname" &&
                key !== "rowno"
              ) {
                this.tableFields.push({
                  title: this.getFinancialYear(key, this.rawDataType),
                  name: this.rawData[0][key],
                  rowind: key,
                  sort_order: key.replace("Year", "")
                });
              } else {
              }
            }
          }
        }
        console.log(this.tableFields);
        this.tableFields = this.sorted_fields_desc(
          this.tableFields,
          "sort_order"
        );
      } else if (this.rawDataType === "share_holding_pattern") {
        this.tableFields.push(
          {
            title: "yrc",
            name: "Status as of",
            rowind: "1",
            sort_order: 1,
            isNumeric: false
          },
          {
            title: "PromoterHolding",
            name: "Promoter Holding",
            rowind: "1",
            sort_order: 2,
            isNumeric: true
          },
          {
            title: "FIIHolding",
            name: "FII Holding",
            rowind: "1",
            sort_order: 3,
            isNumeric: true
          },
          {
            title: "MutualFundHolding",
            name: "Mutual Fund Holding",
            rowind: "1",
            sort_order: 4,
            isNumeric: true
          },
          {
            title: "Others",
            name: "Others",
            rowind: "1",
            sort_order: 4,
            isNumeric: true
          }
        );
        this.downLoadableData = this.getDownLoadableDataFromTable(
          this.tableFields,
          this.rawData,
          "title"
        );
      } else if (this.rawDataType === "mf_holding") {
        if (this.rawData.length > 0) {
          this.tableFields.push(
            {
              title: "sch_name",
              name: "Scheme Name",
              rowind: "1",
              sort_order: 1,
              isNumeric: false
            },
            {
              title: "mktvalue",
              name: "Amount Invested (CR)",
              rowind: "1",
              sort_order: 2,
              isNumeric: true
            },
            {
              title: "perc_hold",
              name: "% Net Assets",
              rowind: "1",
              sort_order: 3,
              isNumeric: true
            },
            {
              title: "totnav",
              name: "Total NAV (CR)",
              rowind: "1",
              sort_order: 4,
              isNumeric: true
            }
          );
        }
      } else if (
        this.rawDataType === "price_bse" ||
        this.rawDataType === "price_nse"
      ) {
        this.tableFields.push(
          {
            title: "date",
            name: "Year",
            rowind: "1",
            sort_order: 1,
            isNumeric: false
          },
          {
            title: "High",
            name: "High (CR)",
            rowind: "1",
            sort_order: 2,
            isNumeric: true
          },
          {
            title: "Low",
            name: "Low (CR)",
            rowind: "1",
            sort_order: 3,
            isNumeric: true
          },
          {
            title: "Close",
            name: "Close (CR)",
            rowind: "1",
            sort_order: 4,
            isNumeric: true
          }
          // {
          //   title: "totnav",
          //   name: "Total NAV (CR)",
          //   rowind: "1",
          //   sort_order: 4,
          //   isNumeric: true
          // }
        );
      } else if (this.rawDataType === "score_board") {
        this.tableFields.push(
          {
            title: "cn",
            name: "Company",
            rowind: "1",
            sort_order: 1,
            isNumeric: false
          },
          {
            title: "lname",
            name: "Company Long Name",
            rowind: "1",
            sort_order: 50,
            isNumeric: false
          },
          {
            title: "co_code",
            name: "Company Code",
            rowind: "1",
            sort_order: 51,
            isNumeric: false
          },
          // {
          //   title: "sno",
          //   name: "Section Name",
          //   rowind: "1",
          //   sort_order: 2,
          //   isNumeric: false
          // },
          {
            title: "sc_code",
            name: "BSE Scrip CODE  ",
            rowind: "1",
            sort_order: 3,
            isNumeric: false
          },
          {
            title: "yrc",
            name: "YEAR END",
            rowind: "1",
            sort_order: 4,
            isNumeric: false
          },
          {
            title: "scr_dt",
            name: "Source Date",
            rowind: "1",
            sort_order: 5,
            isNumeric: false
          },
          {
            title: "noofmonths",
            name: "NO. OF Months in FY",
            rowind: "1",
            sort_order: 6,
            isNumeric: false
          },
          {
            title: "var",
            name: "Full year NP Var%",
            rowind: "1",
            sort_order: 7,
            isNumeric: false
          },
          {
            title: "eqc",
            name: "Equity",
            rowind: "1",
            sort_order: 8,
            isNumeric: false
          },
          {
            title: "fv",
            name: "Face Value",
            rowind: "1",
            sort_order: 9,
            isNumeric: false
          },
          {
            title: "res",
            name: "Reserves",
            rowind: "1",
            sort_order: 10,
            isNumeric: false
          },
          {
            title: "div",
            name: "Dividend(%)",
            rowind: "1",
            sort_order: 11,
            isNumeric: false
          },
          {
            title: "sto",
            name: "Sales Turnover",
            rowind: "1",
            sort_order: 12,
            isNumeric: false
          },
          {
            title: "np",
            name: "Net Profit",
            rowind: "1",
            sort_order: 13,
            isNumeric: false
          },
          {
            title: "cps",
            name: "Full Year Cps",
            rowind: "1",
            sort_order: 14,
            isNumeric: false
          },
          {
            title: "eps",
            name: "Earning Per Share",
            rowind: "1",
            sort_order: 15,
            isNumeric: false
          },
          {
            title: "vpcps",
            name: "Quarte CPS",
            rowind: "1",
            sort_order: 16,
            isNumeric: false
          },
          {
            title: "iyrc1",
            name: "Latest Quarter Year End",
            rowind: "1",
            sort_order: 17,
            isNumeric: false
          },
          {
            title: "vsto",
            name: "Latest Quarter  Sales  Rs. Cr.",
            rowind: "1",
            sort_order: 18,
            isNumeric: false
          },
          {
            title: "peps",
            name: "EPS",
            rowind: "1",
            sort_order: 19,
            isNumeric: false
          },
          {
            title: "pn",
            name: "Industry",
            rowind: "1",
            sort_order: 20,
            isNumeric: false
          },
          {
            title: "peps",
            name: "EPS",
            rowind: "1",
            sort_order: 21,
            isNumeric: false
          },
          {
            title: "pn",
            name: "Industry",
            rowind: "1",
            sort_order: 22,
            isNumeric: false
          },
          {
            title: "bv",
            name: "Book Value",
            rowind: "1",
            sort_order: 23,
            isNumeric: false
          },
          {
            title: "latronw",
            name: "Networth",
            rowind: "1",
            sort_order: 24,
            isNumeric: false
          },
          {
            title: "ape",
            name: "Yearly P/E Ratio",
            rowind: "1",
            sort_order: 25,
            isNumeric: false
          },
          {
            title: "apc",
            name: "Yearly P/C Ratio",
            rowind: "1",
            sort_order: 26,
            isNumeric: false
          },
          {
            title: "ncmpr",
            name: "NSE Price",
            rowind: "1",
            sort_order: 25,
            isNumeric: false
          },
          {
            title: "cmpr",
            name: "BSE price",
            rowind: "1",
            sort_order: 26,
            isNumeric: false
          },
          {
            title: "mktcap",
            name: "Market Cap",
            rowind: "1",
            sort_order: 27,
            isNumeric: false
          },
          {
            title: "rlfysto",
            name: "Trailing Twelve Months Sales",
            rowind: "1",
            sort_order: 28,
            isNumeric: false
          },
          {
            title: "rlfyop",
            name: "Trailing 12 month op",
            rowind: "1",
            sort_order: 29,
            isNumeric: false
          },
          {
            title: "rlfyopm",
            name: "Trailing Twelve Months OPM",
            rowind: "1",
            sort_order: 30,
            isNumeric: false
          },
          {
            title: "rlfygp",
            name: "Trailing 12 month GP",
            rowind: "1",
            sort_order: 31,
            isNumeric: false
          },
          {
            title: "rlfygpm",
            name: "Trailing Twelve Months GPM",
            rowind: "1",
            sort_order: 32,
            isNumeric: false
          },
          {
            title: "rlfynp",
            name: "Trailing 12 month NP",
            rowind: "1",
            sort_order: 33,
            isNumeric: false
          },
          {
            title: "rlfynpv",
            name: "Trailing Twelve Months NPV",
            rowind: "1",
            sort_order: 34,
            isNumeric: false
          },
          {
            title: "rlfyeps",
            name: "Trailing 12 month EPS",
            rowind: "1",
            sort_order: 35,
            isNumeric: false
          },
          {
            title: "rlfype",
            name: "Trailing Twelve Months PE",
            rowind: "1",
            sort_order: 36,
            isNumeric: false
          },
          {
            title: "rlfycps",
            name: "Trailing 12 month CPS",
            rowind: "1",
            sort_order: 37,
            isNumeric: false
          },
          {
            title: "rlfypc",
            name: "Month CPS",
            rowind: "1",
            sort_order: 38,
            isNumeric: false
          },
          {
            title: "rlfydepn",
            name: "Latest TTM depreciation",
            rowind: "1",
            sort_order: 39,
            isNumeric: false
          },
          {
            title: "lateqc",
            name: "Latest Equity",
            rowind: "1",
            sort_order: 40,
            isNumeric: false
          },
          {
            title: "dlyprice",
            name: "Last Company Price",
            rowind: "1",
            sort_order: 41,
            isNumeric: false
          },
          {
            title: "gbl",
            name: "Gross Block",
            rowind: "1",
            sort_order: 42,
            isNumeric: false
          },
          {
            title: "totoloan",
            name: "Latest Deposits for Banks",
            rowind: "1",
            sort_order: 43,
            isNumeric: false
          },
          {
            title: "advan",
            name: "Advance Given By Bank / Latest Advances for Banks",
            rowind: "1",
            sort_order: 44,
            isNumeric: false
          },
          {
            title: "nnpaasset",
            name: "NetProfitAsset Latest Net Non Performing Assets (Rs. Cr)",
            rowind: "1",
            sort_order: 45,
            isNumeric: false
          },
          {
            title: "latopm",
            name: "latopm Full Year Operating Profit Margin",
            rowind: "1",
            sort_order: 46,
            isNumeric: false
          },
          {
            title: "latgpm",
            name: "latgpm Full Year Gross Profit Margin",
            rowind: "1",
            sort_order: 47,
            isNumeric: false
          },
          {
            title: "lathyopm",
            name: "lathyopm Latest Quarter Operating Profit Margin",
            rowind: "1",
            sort_order: 48,
            isNumeric: false
          },
          {
            title: "pvbv",
            name: "Price value to Book value",
            rowind: "1",
            sort_order: 49,
            isNumeric: false
          }
        );
      } else if (this.rawDataType === "board_of_directors") {
        this.tableRows = [];
        this.tableColumns = [];
        var rowKeys = Object.keys(this.rawData[0].boardOfdirectorslist);
        rowKeys.forEach((val, key) => {
          console.log("Rows", key, val);
          if (val !== "Year" && val !== "SerialNumber") {
            this.tableColumns.push({
              title: val,
              name: this.getCustomLabel(val)
                ? this.getCustomLabel(val)
                : this.getLabel(val),
              sort_order:
                val === "DirectorName"
                  ? 1
                  : val === "Qualification"
                    ? 2
                    : val === "DirectorDesignation"
                      ? 3
                      : val === "ExecutiveStatus"
                        ? 4
                        : val === "Remuneration"
                          ? 5
                          : 99
            });
          }
        });
        this.tableColumns = this.sorted_fields_asc(
          this.tableColumns,
          "sort_order"
        );
      } else if (
        this.rawDataType === "Open_Issues" ||
        this.rawDataType === "Closed_Issues" ||
        this.rawDataType === "new_issues_monitor"
      ) {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "lname"
                    ? 1
                    : val === "ISSUETYPE"
                      ? 2
                      : val === "ISSUESIZE"
                        ? 3
                        : val === "Offer_Price"
                          ? 4
                          : val === "OPENDATE"
                            ? 5
                            : val === "CLOSDATE"
                              ? 5
                              : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (
        this.rawDataType === "new_listing_BSE" ||
        this.rawDataType === "new_listing_NSE" ||
        this.rawDataType === "best_performance_BSE" ||
        this.rawDataType === "best_performance_NSE"
      ) {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                      ? 1
                      : val === "lname"
                        ? 2
                        : val === "CO_NAME"
                          ? 3
                          : val === "LISTDATE"
                            ? 4
                            : val === "listprice"
                              ? 5
                              : val === "LISTVOL"
                                ? 7
                                : val === "IssueSize"
                                  ? 8
                                  : val === "OfferPrice"
                                    ? 9
                                    : val === "HIGH"
                                      ? 10
                                      : val === "LOW"
                                        ? 11
                                        : val === "CLOSE"
                                          ? 12
                                          : val === "VOLUME"
                                            ? 13
                                            : val === "LastTr_Date"
                                              ? 14
                                              : val === "PerChange"
                                                ? 15
                                                : val === "IssueDate"
                                                  ? 16
                                                  : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (this.rawDataType === "company_news") {
        this.tableFields.push(
          {
            title: "sch_name",
            name: "Scheme Name",
            rowind: "1",
            sort_order: 1,
            isNumeric: false
          },
          {
            title: "mktvalue",
            name: "Amount Invested (CR)",
            rowind: "1",
            sort_order: 2,
            isNumeric: true
          },
          {
            title: "perc_hold",
            name: "% Net Assets",
            rowind: "1",
            sort_order: 3,
            isNumeric: true
          },
          {
            title: "totnav",
            name: "Total NAV (CR)",
            rowind: "1",
            sort_order: 4,
            isNumeric: true
          }
        );
      } else if (
        this.rawDataType === "avg_trade_volume" ||
        this.rawDataType === "index_constituents"
      ) {
        var columns = Object.keys(this.rawData);
        console.log(columns);
        columns.forEach((val, key) => {
          console.log(val);
          if (val !== "_id" && val !== "symbol" && val !== "co_code") {
            this.tableFields.push({
              title: val,
              name: this.getCustomLabel(val)
                ? this.getCustomLabel(val)
                : this.getLabel(val),
              orgKey: key,
              sort_order: 1,
              isNumeric: val === "CompanyName" ? 0 : 1
            });
          }
        });
        this.tableRows = this.sorted_fields_asc(this.tableRows, "sort_order");
      } else if (this.rawDataType === "corporate_actionB") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                      ? 1
                      : val === "co_name"
                        ? 2
                        : val === "AnnouncementDate"
                          ? 3
                          : val === "RecordDate"
                            ? 4
                            : val === "BonusDate"
                              ? 5
                              : val === "BonusRatio"
                                ? 7
                                : val === "remark"
                                  ? 8
                                  : val === "Description"
                                    ? 9
                                    : 99
              });
            }
          });
        }
      } else if (this.rawDataType === "corporate_actionS") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                      ? 1
                      : val === "co_name"
                        ? 2
                        : val === "AnnouncementDate"
                          ? 3
                          : val === "recorddate"
                            ? 4
                            : val === "SplitDate"
                              ? 5
                              : val === "FVBefore"
                                ? 7
                                : val === "FVAfter"
                                  ? 8
                                  : val === "remark"
                                    ? 9
                                    : val === "Description"
                                      ? 10
                                      : val === "SplitRatio"
                                        ? 11
                                        : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (this.rawDataType === "corporate_actionR") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                      ? 1
                      : val === "co_name"
                        ? 2
                        : val === "AnnouncementDate"
                          ? 3
                          : val === "DivDate"
                            ? 4
                            : val === "DivAmount"
                              ? 5
                              : val === "DivPer"
                                ? 7
                                : val === "remark"
                                  ? 8
                                  : val === "Description"
                                    ? 9
                                    : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (this.rawDataType === "corporate_actionBM") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type:
                  val === "AnnouncementDate" || val === "BMdate" ? "date" : "",
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                      ? 1
                      : val === "co_name"
                        ? 2
                        : val === "AnnouncementDate"
                          ? 3
                          : val === "BMdate"
                            ? 4
                            : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(
            this.rawData,
            "AnnouncementDate"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (
        this.rawDataType === "bse_announcements" ||
        this.rawDataType === "nse_announcements" ||
        this.rawDataType === "bse_eod_announcements"
      ) {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (
              val !== "CompanyLongName" &&
              val !== "_id" &&
              val !== "co_code" &&
              val !== "bsecode" &&
              val !== "symbol"
            ) {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "Date"
                    ? 1
                    : val === "Symbol"
                      ? 2
                      : val === "Caption"
                        ? 3
                        : val === "memo"
                          ? 4
                          : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (
        this.rawDataType === "bse_board_meetings" ||
        this.rawDataType === "nse_board_meetings"
      ) {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (
              val !== "CompanyName" &&
              val !== "_id" &&
              val !== "co_code" &&
              val !== "Symbol"
            ) {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order: val === "Date" ? 1 : val === "Note" ? 2 : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (this.rawDataType === "shares_outstanding") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "_id" && val !== "CO_CODE") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "YearRC"
                      ? 2
                      : val === "sharesoutstanding"
                        ? 3
                        : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_desc(
            this.rawData,
            "YearRC"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "mcap_yearly") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "_id" && val !== "CO_CODE") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "YearRC"
                      ? 2
                      : val === "MCAP"
                        ? 3
                        : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_desc(
            this.rawData,
            "YearRC"
          );
        }
      } else if (this.rawDataType === "yearly_dividend") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "_id" && val !== "co_code") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "yrc"
                      ? 2
                      : val === "EquityDividend"
                        ? 3
                        : val === "DividendPecentage"
                          ? 4
                          : val === "DivYearield"
                            ? 5
                            : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields, this.tableColumns);
      } else if (this.rawDataType === "insider_trading") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (
              val !== "CO_CODE" &&
              val !== "BSECODE" &&
              val !== "CO_NAME" &&
              val !== "_id"
            ) {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type:
                  val === "FROMDTACQ" ||
                    val === "INTDATE" ||
                    val === "REPEXCH" ||
                    val === "TODTACQ"
                    ? "date"
                    : "",
                sort_order:
                  val === "PERSONNAME"
                    ? 0
                    : val === "CATEGORYear"
                      ? 1
                      : val === "SECTYearPEPR"
                        ? 2
                        : val === "SECNOPR"
                          ? 3
                          : val === "SECPERCPR"
                            ? 4
                            : val === "SECTYearPE"
                              ? 5
                              : val === "SECNO"
                                ? 7
                                : val === "SECVALUE"
                                  ? 8
                                  : val === "TRANSTYearPE"
                                    ? 9
                                    : val === "SECTYearPEPO"
                                      ? 10
                                      : val === "SECNOPO"
                                        ? 11
                                        : val === "SECPERCPO"
                                          ? 12
                                          : val === "FROMDTACQ"
                                            ? 13
                                            : val === "TODTACQ"
                                              ? 14
                                              : val === "INTDATE"
                                                ? 15
                                                : val === "ACQMODE"
                                                  ? 16
                                                  : val === "EXCH"
                                                    ? 17
                                                    : val === "REPEXCH"
                                                      ? 18
                                                      : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields, this.tableColumns);
      } else if (this.rawDataType === "insider_trading") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "BSECODE" && val !== "_id") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: "",
                sort_order:
                  val === "CO_CODE"
                    ? 0
                    : val === "YearRC"
                      ? 1
                      : val === "CapitalExpenditure"
                        ? 2
                        : val === "RecurringExpenditure"
                          ? 3
                          : val === "TotalExpendiiture"
                            ? 4
                            : val === "TotalRDexpenditureaspercentageofnetturnover"
                              ? 5
                              : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields, this.tableColumns);
      } else if (this.rawDataType === "Finished_Products") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "co_code") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "YRC" ? "year" : "",
                sort_order:
                  val === "PRNAME"
                    ? 1
                    : val === "UnitofMeasurement"
                      ? 2
                      : val === "SalesPercentage"
                        ? 3
                        : val === "InstalledCapacity"
                          ? 4
                          : val === "Production"
                            ? 5
                            : val === "SALEQTY"
                              ? 6
                              : val === "SALEVAL"
                                ? 7
                                : val === "YRC"
                                  ? 0
                                  : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_desc(
            this.rawData,
            "YRC"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      } else if (this.rawDataType === "Shareholding_MorethanOnePercent") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            // console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "co_code") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "date" || val === "expdate" ? "date" : "",
                sort_order:
                  val === "co_code"
                    ? 0
                    : val === "name"
                      ? 1
                      : val === "type"
                        ? 2
                        : val === "noofshares"
                          ? 3
                          : val === "perstake"
                            ? 4
                            : val === "date"
                              ? 5
                              : 99
              });
            }
          });
          console.log(this.tableRows, this.tableColumns);
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "date");
        }
      } else if (this.rawDataType === "Capital_Expenditure") {
        this.tableRows = [];
        this.tableColumns = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "co_code") {
              this.tableColumns.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "yrc" ? "year" : "",
                sort_order:
                  val === "co_code" ? 1 : val === "capitalexpenditure" ? 2 : 99
              });
            }
          });
          this.tableColumns = this.sorted_fields_asc(
            this.tableColumns,
            "sort_order"
          );
          this.rawData = this.sorted_fields_desc(
            this.rawData,
            "yrc"
          );
        }
        console.log(this.tableRows, this.tableColumns);
      }
    },
    getsort(ind) {
      return parseInt(
        this.rawDataType === "quarterly_result" ||
          this.rawDataType === "quarterly_result_c" ||
          this.rawDataType === "quarterly_result_s"
          ? key.replace("Year", "")
          : key.replace("y", "")
      );
    },
    setAccordian(key, ind) {
      if (this.selRowInd != ind) {
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = ind;
        this.rawDataList[ind].open = !this.rawDataList[ind].open;
        this.rawDataType = this.rawDataList[ind].id;
        this.getRawData();
      } else if (this.selRowInd == ind) {
        this.selRowInd = ind;
        this.rawDataList[ind].open = !this.rawDataList[ind].open;
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log("TabChange :::", this.selRowInd, tabIndex, this.rawDataList);
      if (this.selRowInd != tabIndex) {
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.selTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("rawtab", this.rawDataList[tabIndex].id);
        localStorage.setItem("selTab", this.rawDataList[tabIndex].value);
        console.log('###### >>>', this.rawDataList[tabIndex]);
        this.getRawData();
      } else if (this.selRowInd == tabIndex) {
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
      }
    },
    paramChange() {
      this.rawData = [];
      this.tableFields = [];
      (this.companies = []),
        (this.selectedCompanies = []),
        (this.isCompSel = true),
        (this.isCompared = false);
      let myself = this;
      http.post(
        this.rawDataApi,
        {
          rowFieldName: this.rawDataType + "_" + this.param,
          co_code: this.company.co_code
        },
        (error, response) => {
          console.log("Response", response.data);
          this.rawData = response.data.length > 0 ? response.data : [];
          this.getCompanies();
        }
      );
      // if (this.isCompared) {
      //   this.compareCompanies();
      // }
    },
    selAllCompany(e) {
      if (e.target.checked) {
        this.companies.forEach((val, index) => {
          this.selectedCompanies.push(val.id);
        });
      } else {
        this.selectedCompanies = [];
      }
    },
    addCompany(e) {
      if (e.target.checked) {
        this.selectedCompanies.push(e.target.value);
      } else {
        this.selectedCompanies.splice(
          this.selectedCompanies.indexOf(e.target.value)
        );
      }
    },
    compareCompanies() {
      console.log(this.selectedCompanies);
      if (this.selectedCompanies.length > 0) {
        // this.isloading = true;
        this.isCompSel = true;
        var tableField = [];
        var param = this.param;
        var tabKeys = Object.keys(this.rawData[0]);
        // var tabKeys = Object.keys(this.rawData[param][0]);
        tabKeys.forEach((val, key) => {
          if (val != "@reporttype" && val !== "co_code" && val !== "_id")
            tableField.push({
              title: val,
              name: this.getCustomLabel(val) ? this.getCustomLabel(val) : val,
              sort_order: key
            });
        });
        this.tableFields = tableField;
        // this.isloading = false;
        this.isCompared = true;
      } else {
        this.isCompSel = false;
        this.isCompared = false;
      }
    },
    backToCompare() {
      this.isCompSel = false;
      this.isCompared = false;
      this.tableFields = [];
      this.selectedCompanies = [];
      $("input.checkall").prop("checked", false);
      this.getCompanies();
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function (error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code;
        }
      });
    },
    getCompRawData() {
      console.log("Get RawData", this.selComp);
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        this.company.companyname = this.selComp.companyname;
        this.company.co_code = this.selComp.co_code;
        console.log(
          "Company",
          this.company.co_code,
          "=>",
          this.company.companyname
        );
        // this.getTabData(this.selRowInd, {}, {});
        this.getRawData();
      }
    }
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      selTab: "",
      companyList: [],
      lastSelectItem: {},
      selComp: "",
      company: { co_code: "", companyname: "" },
      downLoadableData: [],
      tableFields: [],
      param: "balancesheet",
      currentComp: "",
      rawDataList: [
        { id: "balance_sheet", value: "Balance Sheet", open: false, items: {} },
        {
          id: "balance_sheet_c",
          value: "Balance Sheet (C)",
          open: false,
          items: {}
        },
        {
          id: "balance_sheet_s",
          value: "Balance Sheet (S)",
          open: false,
          items: {}
        },
        {
          id: "profit_and_loss",
          value: "Profit & Loss",
          open: false,
          items: {}
        },
        {
          id: "profit_and_loss_c",
          value: "Profit & Loss (C)",
          open: false,
          items: {}
        },
        {
          id: "profit_and_loss_s",
          value: "Profit & Loss (S)",
          open: false,
          items: {}
        },
        {//New Tab for Annual Result-29-07-2026
          id: "annual_result",
          value: "Annual Result",
          open: false,
          items: {}
        },
        {
          id: "annual_result_c",
          value: "Annual Result (C)",
          open: false,
          items: {}
        },
        {
          id: "annual_result_s",
          value: "Annual Result (S)",
          open: false,
          items: {}
        },//New Tab for Annual Result-29-07-2026
        { //New Tab for Annual Result P&L-03-08-2026
          id: "annual_profit_and_loss_result",
          value: "Annual Result P&L",
          open: false,
          items: {}
        },
        {
          id: "annual_profit_and_loss_result_c",
          value: "Annual Result P&L (C)",
          open: false,
          items: {}
        },
        {
          id: "annual_profit_and_loss_result_s",
          value: "Annual Result P&L (S)",
          open: false,
          items: {}
        },//New Tab for Annual Result P&L-03-08-2026
        { //New Tab for Annual Result Cash Flow-03-08-2026
          id: "annual_cashflow_result",
          value: "Annual Result Cash Flow",
          open: false,
          items: {}
        },
        {
          id: "annual_cashflow_result_c",
          value: "Annual Result Cash Flow (C)",
          open: false,
          items: {}
        },
        {
          id: "annual_cashflow_result_s",
          value: "Annual Result Cash Flow (S)",
          open: false,
          items: {}
        },//New Tab for Annual Result Cash Flow-03-08-2026

        { id: "cashflow", value: "Cashflow", open: false, items: {} },
        { id: "cashflow_c", value: "Cashflow (C)", open: false, items: {} },
        { id: "cashflow_s", value: "Cashflow (S)", open: false, items: {} },
        {
          id: "quarterly_result",
          value: "Quarterly Result",
          open: false,
          items: {}
        },
        {
          id: "quarterly_result_c",
          value: "Quarterly Result (C)",
          open: false,
          items: {}
        },
        {
          id: "quarterly_result_s",
          value: "Quarterly Result (S)",
          open: false,
          items: {}
        },
        {
          id: "half_yearly_result",
          value: "Half-Yearly Result",
          open: false,
          items: {}
        },
        {
          id: "half_yearly_result_c",
          value: "Half-Yearly Result (C)",
          open: false,
          items: {}
        },
        {
          id: "half_yearly_result_s",
          value: "Half-Yearly Result (S)",
          open: false,
          items: {}
        },
        {
          id: "index_constituents",
          value: "Index Constituents",
          open: false,
          items: {}
        },
        {
          id: "avg_trade_volume",
          value: "Avg Trade Volume",
          open: false,
          items: {}
        },
        {
          id: "share_holding_pattern",
          value: "Share Holding Pattern",
          open: false,
          items: {}
        },
        { id: "score_board", value: "Score Board", open: false, items: {} },
        {
          id: "price_bse",
          value: "Share Prices BSE",
          open: false,
          items: {}
        },
        {
          id: "price_nse",
          value: "Share Prices NSE",
          open: false,
          items: {}
        },
        {
          id: "key_financial_ratios",
          value: "Key Financial Ratios",
          open: false,
          items: {}
        },
        { id: "directors_reports", value: "Director's Report" },
        { id: "mf_holding", value: "MF Holdings", open: false, items: {} },
        { id: "company_news", value: "Company News", open: false, items: {} },
        {
          id: "peer_comparison", // http://api.nobiasinvesting.com/rawDataList/peer_comparison_balancesheet/6
          value: "Peer Comparison",
          open: false,
          items: {}
        },
        {
          id: "quote_details",
          value: "Get Quote",
          open: false,
          items: {}
        },
        {
          id: "company_background",
          value: "Background",
          open: false,
          items: {}
        },
        {
          id: "board_of_directors",
          value: "Board of Directors",
          open: false,
          items: {}
        },
        {
          id: "bse_board_meetings",
          value: "BSE Board Meetings Forthcoming",
          open: false,
          items: {}
        },
        {
          id: "nse_board_meetings",
          value: "NSE Board Meetings Forthcoming",
          open: false,
          items: {}
        },
        {
          id: "corporate_actionBM",
          value: "Corporate Action BM",
          open: false,
          items: {}
        },
        {
          id: "corporate_actionB",
          value: "Corporate Action Bonus",
          open: false,
          items: {}
        },
        {
          id: "corporate_actionR",
          value: "Corporate Action Rights",
          open: false,
          items: {}
        },
        {
          id: "corporate_actionS",
          value: "Corporate Action Splits",
          open: false,
          items: {}
        },
        {
          id: "bse_announcements",
          value: "BSE Announcements",
          open: false,
          items: {}
        },
        {
          id: "nse_announcements",
          value: "NSE Announcements",
          open: false,
          items: {}
        },
        {
          id: "bse_eod_announcements",
          value: "BSE EOD Announcement",
          open: false,
          items: {}
        },
        // {
        //   id: "bse_board_meetings",
        //   value: "BSE Board Meetings forthcoming",
        //   open: false,
        //   items: {}
        // },
        // {
        //   id: "nse_board_meetings",
        //   value: "NSE Board Meetings forthcoming",
        //   open: false,
        //   items: {}
        // },
        {
          id: "shares_outstanding",
          value: "Shares Outstanding",
          open: false,
          items: {}
        },
        { id: "mcap_yearly", value: "MCAP Yearly", open: false, items: {} },
        {
          id: "yearly_dividend",
          value: "Yearly Dividend",
          open: false,
          items: {}
        },
        {
          id: "insider_trading",
          value: "Insider Trading",
          open: false,
          items: {}
        },
        {
          id: "research_and_development",
          value: "Research & Development",
          open: false,
          items: {}
        },
        { id: "Finished_Products", value: "Finished Products", items: {} },
        {
          id: "Shareholding_MorethanOnePercent",
          value: "Shareholding more than 1%",
          items: {}
        },
        { id: "Capital_Expenditure", value: "Capital Expenditure", items: {} }
      ],
      rawDataType: "balance_sheet",
      rawDataApi: "rawDataList",
      rawData: [],
      fillableData: [],
      selRowInd: 0,
      companies: [],
      selectedCompanies: [],
      isCompSel: true,
      isCompared: false,
      tableColumns: [],
      tableRows: [],
      tabOneRawDataType: [
        "balance_sheet",
        "balance_sheet_c",
        "balance_sheet_s",
        "profit_and_loss",
        "profit_and_loss_c",
        "profit_and_loss_s",
        "annual_result",
        "annual_result_c",
        "annual_result_s",
        "annual_profit_and_loss_result",
        "annual_profit_and_loss_result_c",
        "annual_profit_and_loss_result_s",
        "annual_cashflow_result",
        "annual_cashflow_result_c",
        "annual_cashflow_result_s",
        "cashflow",
        "cashflow_c",
        "cashflow_s",
        "quarterly_result",
        "quarterly_result_c",
        "quarterly_result_s",
        "half_yearly_result",
        "half_yearly_result_c",
        "half_yearly_result_s",
        "company_master",
        "mf_holding",
        "price_bse",
        "price_nse",
        "board_of_directors",
        "company_news",
        "bse_announcements",
        "nse_announcements",
        "bse_eod_announcements",
        "bse_board_meetings",
        "nse_board_meetings",
        "shares_outstanding",
        "mcap_yearly",
        "yearly_dividend",
        "insider_trading",
        "research_and_development",
        "Finished_Products",
        "Shareholding_MorethanOnePercent",
        "Capital_Expenditure"
      ]
    };
  },
  computed: {
    mfHoldingData: function () {
      return this.rawData.filter(function (row, index) {
        return index !== "_id" && index !== "co_code";
      });
    },
    keyFinancialRatios: function () {
      return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist']) ? this.rawData[0]['keyfinancialratiolist'] : [];
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/rawdata.vue